import type { IntrospectionQuery } from 'graphql';
export default {
  __schema: {
    queryType: {
      name: 'Query',
    },
    mutationType: {
      name: 'Mutation',
    },
    subscriptionType: null,
    types: [
      {
        kind: 'OBJECT',
        name: 'BorderMargins',
        fields: [
          {
            name: 'left',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'top',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'right',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'bottom',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'BorderObject',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'borderMargins',
            type: {
              kind: 'OBJECT',
              name: 'BorderMargins',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderStyleProperties',
            type: {
              kind: 'OBJECT',
              name: 'BorderStyleProperties',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'legacyCosmeticItemType',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'BorderStyleProperties',
        fields: [
          {
            name: 'borders',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'borderWeight',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'shadowWeight',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'penStyle',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CaptionAlignment',
        fields: [
          {
            name: 'horizontalAlignment',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'horizontalOffset',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'relativeLayout',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'verticalAlignment',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'verticalOffset',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'INTERFACE',
        name: 'CaptureObjectBase',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'Gauge',
          },
          {
            kind: 'OBJECT',
            name: 'HandwritingRecognitionObject',
          },
          {
            kind: 'OBJECT',
            name: 'ManualImageAreaText',
          },
          {
            kind: 'OBJECT',
            name: 'PickList',
          },
          {
            kind: 'OBJECT',
            name: 'TickboxGroup',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Code',
        fields: [
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'index',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CodeList',
        fields: [
          {
            name: 'captionColumn',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'codes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Code',
                    ofType: null,
                  },
                },
              },
            },
            args: [
              {
                name: 'skipExternal',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
            ],
          },
          {
            name: 'connectionId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'isExternal',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'searchColumn',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'INTERFACE',
        name: 'Colours',
        fields: [
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'CosmeticItem',
          },
          {
            kind: 'OBJECT',
            name: 'FieldData',
          },
          {
            kind: 'OBJECT',
            name: 'HandwritingRecognitionObject',
          },
          {
            kind: 'OBJECT',
            name: 'Image',
          },
          {
            kind: 'OBJECT',
            name: 'Line',
          },
          {
            kind: 'OBJECT',
            name: 'ManualImageAreaText',
          },
          {
            kind: 'OBJECT',
            name: 'PickList',
          },
          {
            kind: 'OBJECT',
            name: 'QuestionCaption',
          },
          {
            kind: 'OBJECT',
            name: 'Rectangle',
          },
          {
            kind: 'OBJECT',
            name: 'RoundedRectangle',
          },
          {
            kind: 'OBJECT',
            name: 'TextBox',
          },
          {
            kind: 'OBJECT',
            name: 'TickboxGroup',
          },
          {
            kind: 'OBJECT',
            name: 'UrlLink',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CompletionAction',
        fields: [
          {
            name: 'redirectImmediately',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'redirectionDelay',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'redirectUri',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Connection',
        fields: [
          {
            name: 'columns',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'jsonData',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'relations',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'DataRelation',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Coordinates',
        fields: [
          {
            name: 'x1',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'y1',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'x2',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'y2',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CosmeticItem',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'htmlText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'textRotation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'INTERFACE',
        name: 'CsvDownloadPermissions',
        fields: [
          {
            name: 'canDownloadSubmittedDataAsCsv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'WebGroup',
          },
          {
            kind: 'OBJECT',
            name: 'WebUser',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'DataDerivationResult',
        fields: [
          {
            name: 'respondent',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Respondent',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'processingErrors',
            type: {
              kind: 'LIST',
              ofType: {
                kind: 'OBJECT',
                name: 'ProcessingError',
                ofType: null,
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DataRelation',
        fields: [
          {
            name: 'columnName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'relation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'DataRelationDescriptor',
                ofType: null,
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DataRelationDescriptor',
        fields: [
          {
            name: 'columnName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'connection',
            type: {
              kind: 'LIST',
              ofType: {
                kind: 'OBJECT',
                name: 'Connection',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'connectionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteRespondentResult',
        fields: [
          {
            name: 'isSuccess',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'message',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'resultCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'INTERFACE',
        name: 'DesignObjectBase',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'CosmeticItem',
          },
          {
            kind: 'OBJECT',
            name: 'FieldData',
          },
          {
            kind: 'OBJECT',
            name: 'Gauge',
          },
          {
            kind: 'OBJECT',
            name: 'HandwritingRecognitionObject',
          },
          {
            kind: 'OBJECT',
            name: 'Image',
          },
          {
            kind: 'OBJECT',
            name: 'Line',
          },
          {
            kind: 'OBJECT',
            name: 'ManualImageAreaText',
          },
          {
            kind: 'OBJECT',
            name: 'PickList',
          },
          {
            kind: 'OBJECT',
            name: 'Rectangle',
          },
          {
            kind: 'OBJECT',
            name: 'RoundedRectangle',
          },
          {
            kind: 'OBJECT',
            name: 'TextBox',
          },
          {
            kind: 'OBJECT',
            name: 'TickboxGroup',
          },
          {
            kind: 'OBJECT',
            name: 'UrlLink',
          },
        ],
      },
      {
        kind: 'UNION',
        name: 'DesignObjectsUnion',
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'Image',
          },
          {
            kind: 'OBJECT',
            name: 'TextBox',
          },
          {
            kind: 'OBJECT',
            name: 'FieldData',
          },
          {
            kind: 'OBJECT',
            name: 'UrlLink',
          },
          {
            kind: 'OBJECT',
            name: 'CosmeticItem',
          },
          {
            kind: 'OBJECT',
            name: 'Rectangle',
          },
          {
            kind: 'OBJECT',
            name: 'RoundedRectangle',
          },
          {
            kind: 'OBJECT',
            name: 'Line',
          },
          {
            kind: 'OBJECT',
            name: 'HandwritingRecognitionObject',
          },
          {
            kind: 'OBJECT',
            name: 'ManualImageAreaText',
          },
          {
            kind: 'OBJECT',
            name: 'PickList',
          },
          {
            kind: 'OBJECT',
            name: 'TickboxGroup',
          },
          {
            kind: 'OBJECT',
            name: 'Gauge',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Dimensions',
        fields: [
          {
            name: 'height',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'width',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Field',
        fields: [
          {
            name: 'allowDerivedDataToOverWrite',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'connection',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Connection',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'caseSensitiveValidation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'checkFormat',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'codeList',
            type: {
              kind: 'OBJECT',
              name: 'CodeList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'dataTypeNew',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'decimals',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'derivation',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'digits',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'fieldFormat',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'fieldProcesses',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fieldType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'formatMask',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'formatRegex',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'mandatory',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'parentFieldIds',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'questionTag',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'responses',
            type: {
              kind: 'OBJECT',
              name: 'Responses',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'searchColumn',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'userValidationErrorMessage',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'validation',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'FieldData',
        fields: [
          {
            name: 'altText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'borderMargins',
            type: {
              kind: 'OBJECT',
              name: 'BorderMargins',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderObject',
            type: {
              kind: 'OBJECT',
              name: 'BorderObject',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderStyleProperties',
            type: {
              kind: 'OBJECT',
              name: 'BorderStyleProperties',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'htmlText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'textRotation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'FieldResponse',
        fields: [
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'value',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Gauge',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'startValue',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'endValue',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'showTickValues',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'tickFrequency',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'gaugeTickValueColour',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'gaugeLineColour',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'gaugeMarkerColour',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'borderObject',
            type: {
              kind: 'OBJECT',
              name: 'BorderObject',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderMargins',
            type: {
              kind: 'OBJECT',
              name: 'BorderMargins',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderStyleProperties',
            type: {
              kind: 'OBJECT',
              name: 'BorderStyleProperties',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'fontAttributes',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fontName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fontSize',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'CaptureObjectBase',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'GlobalOnlineFormsOptions',
        fields: [
          {
            name: 'displayProjectsOnHomeScreen',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'displayTagEntryOnHomeScreen',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'encodeReceipts',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'groupCodesEnabled',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'loginEnabled',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'registrationEnabled',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'userUpdateEnabled',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'HandwritingRecognitionObject',
        fields: [
          {
            name: 'borderWeight',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'boxes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'HandwritingRecognitionObjectBox',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'boxLabelPosition',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cosmeticItems',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CosmeticItem',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'expectedCase',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'layer',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'legend',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'CaptureObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'HandwritingRecognitionObjectBox',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'ordinal',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Image',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'htmlText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'imageObject',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'ImageObject',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'ImageObject',
        fields: [
          {
            name: 'binaryId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'filename',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'height',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'scalingMode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'width',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Line',
        fields: [
          {
            name: 'borderStyleProperties',
            type: {
              kind: 'OBJECT',
              name: 'BorderStyleProperties',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'coordinates',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Coordinates',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Location',
        fields: [
          {
            name: 'layer',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'left',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'top',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'ManualImageAreaText',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidelineMargin',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidelines',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidelineWeight',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'numberOfGuidelines',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'CaptureObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Mutation',
        fields: [
          {
            name: 'importUsers',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'WebUser',
                    ofType: null,
                  },
                },
              },
            },
            args: [
              {
                name: 'userInput',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'LIST',
                    ofType: {
                      kind: 'NON_NULL',
                      ofType: {
                        kind: 'SCALAR',
                        name: 'Any',
                      },
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'updateRespondent',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'SubmissionResult',
                ofType: null,
              },
            },
            args: [
              {
                name: 'submission',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRespondent',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'DeleteRespondentResult',
                ofType: null,
              },
            },
            args: [
              {
                name: 'receipt',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'INTERFACE',
        name: 'ObjectBase',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'BorderObject',
          },
          {
            kind: 'OBJECT',
            name: 'CosmeticItem',
          },
          {
            kind: 'OBJECT',
            name: 'FieldData',
          },
          {
            kind: 'OBJECT',
            name: 'Gauge',
          },
          {
            kind: 'OBJECT',
            name: 'HandwritingRecognitionObject',
          },
          {
            kind: 'OBJECT',
            name: 'HandwritingRecognitionObjectBox',
          },
          {
            kind: 'OBJECT',
            name: 'Image',
          },
          {
            kind: 'OBJECT',
            name: 'Line',
          },
          {
            kind: 'OBJECT',
            name: 'ManualImageAreaText',
          },
          {
            kind: 'OBJECT',
            name: 'PickList',
          },
          {
            kind: 'OBJECT',
            name: 'QuestionCaption',
          },
          {
            kind: 'OBJECT',
            name: 'Rectangle',
          },
          {
            kind: 'OBJECT',
            name: 'RoundedRectangle',
          },
          {
            kind: 'OBJECT',
            name: 'TextBox',
          },
          {
            kind: 'OBJECT',
            name: 'Tickbox',
          },
          {
            kind: 'OBJECT',
            name: 'TickboxGroup',
          },
          {
            kind: 'OBJECT',
            name: 'UrlLink',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'OnlineOptions',
        fields: [
          {
            name: 'isAvailableOffline',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'isVisibleInContents',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'redirectionUrl',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'skinName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'tagName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'OnlinePermissions',
        fields: [
          {
            name: 'canDownloadSubmissionAsPdf',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'canEditSubmitted',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'canReloadSubmitted',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'canSavePartialForms',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'userAuthorisationEnabled',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'responsiveRendering',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'allowRespondentLanguageSelection',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'userSubmissionCountRestricted',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Page',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'objects',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'UNION',
                    name: 'DesignObjectsUnion',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'pageId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'pageOrientation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'INTERFACE',
        name: 'PdfDownloadPermissions',
        fields: [
          {
            name: 'canDownloadSubmissionAsPdf',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [],
      },
      {
        kind: 'OBJECT',
        name: 'PickList',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'responses',
            type: {
              kind: 'OBJECT',
              name: 'Responses',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'sort',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'CaptureObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'ProcessingError',
        fields: [
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'processingErrorMessages',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Project',
        fields: [
          {
            name: 'author',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'connections',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Connection',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'fields',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Field',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'goals',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'identificationMethod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'currentCompletionCount',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'maxCompletionCount',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'currentMaxUserCompletionCount',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'maxUserCompletionCount',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'onlineOptions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OnlineOptions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'onlinePermissions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OnlinePermissions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'pages',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Page',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'projectTranslations',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'ProjectTranslation',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'publicationMedia',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'respondentIdMethod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'routing',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RoutingRule',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'startDate',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'uniqueFieldGuid',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'version',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'ProjectLanguage',
        fields: [
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'language',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nativeLanguage',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'ProjectTranslation',
        fields: [
          {
            name: 'projectName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'subTag',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nativeLanguage',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'translations',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Query',
        fields: [
          {
            name: 'codeList',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CodeList',
                ofType: null,
              },
            },
            args: [
              {
                name: 'codeListId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
              {
                name: 'projectIdentifier',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'connection',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Connection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'connectionId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
              {
                name: 'projectIdentifier',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'derivedData',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'DataDerivationResult',
                ofType: null,
              },
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
            ],
          },
          {
            name: 'ldbData',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Respondent',
                ofType: null,
              },
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
            ],
          },
          {
            name: 'linkedDbAndDerivedData',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'DataDerivationResult',
                ofType: null,
              },
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
            ],
          },
          {
            name: 'onlineFormsOptions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'GlobalOnlineFormsOptions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'partialRespondents',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Respondent',
                    ofType: null,
                  },
                },
              },
            },
            args: [
              {
                name: 'projectId',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
            ],
          },
          {
            name: 'project',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Project',
                ofType: null,
              },
            },
            args: [
              {
                name: 'projectIdentifier',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'projectPage',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Page',
                ofType: null,
              },
            },
            args: [
              {
                name: 'pageNumber',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
              {
                name: 'projectIdentifier',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'projectAvailableTranslations',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'ProjectLanguage',
                    ofType: null,
                  },
                },
              },
            },
            args: [
              {
                name: 'projectId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'projects',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Project',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'respondent',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Respondent',
                ofType: null,
              },
            },
            args: [
              {
                name: 'receipt',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recordsMedia',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RecordsMedia',
                    ofType: null,
                  },
                },
              },
            },
            args: [
              {
                name: 'receipt',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'user',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'WebUser',
                ofType: null,
              },
            },
            args: [
              {
                name: 'userIdentifiers',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'webTheme',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'WebTheme',
                ofType: null,
              },
            },
            args: [
              {
                name: 'themeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'webThemes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'WebTheme',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'QuestionCaption',
        fields: [
          {
            name: 'captionAlignment',
            type: {
              kind: 'OBJECT',
              name: 'CaptionAlignment',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'htmlText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'RecordsMedia',
        fields: [
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'projectNumber',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'level',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'fileName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'data',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'fileType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Rectangle',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderObject',
            type: {
              kind: 'OBJECT',
              name: 'BorderObject',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderMargins',
            type: {
              kind: 'OBJECT',
              name: 'BorderMargins',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderStyleProperties',
            type: {
              kind: 'OBJECT',
              name: 'BorderStyleProperties',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Respondent',
        fields: [
          {
            name: 'identifier',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'RespondentIdentifier',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'receipt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'responses',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'FieldResponse',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'submissionDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'language',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RespondentIdentifier',
        fields: [
          {
            name: 'project',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Project',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'projectId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'recordId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'status',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'uniqueIdData',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'webUserId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'ResponsePositioning',
        fields: [
          {
            name: 'responseHorizontalAlignment',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'responseHorizontalOffset',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'responsePosition',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'responseVerticalAlignment',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'responseVerticalOffset',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Responses',
        fields: [
          {
            name: 'isMultiResponse',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'maximum',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'minimum',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RoundedRectangle',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderObject',
            type: {
              kind: 'OBJECT',
              name: 'BorderObject',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderMargins',
            type: {
              kind: 'OBJECT',
              name: 'BorderMargins',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'borderStyleProperties',
            type: {
              kind: 'OBJECT',
              name: 'BorderStyleProperties',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Routing',
        fields: [
          {
            name: 'fieldsToDisable',
            type: {
              kind: 'OBJECT',
              name: 'RoutingFields',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'fieldsToEnable',
            type: {
              kind: 'OBJECT',
              name: 'RoutingFields',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'gotoField',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RoutingCondition',
        fields: [
          {
            name: 'action',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'hasValue',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'whenField',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RoutingField',
        fields: [
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RoutingFields',
        fields: [
          {
            name: 'fields',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RoutingField',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RoutingRule',
        fields: [
          {
            name: 'conditions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RoutingCondition',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'SubQuestionField',
        fields: [
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'SubmissionError',
        fields: [
          {
            name: 'message',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'SubmissionResult',
        fields: [
          {
            name: 'completionAction',
            type: {
              kind: 'OBJECT',
              name: 'CompletionAction',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'isSuccess',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'message',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'respondent',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Respondent',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'resultCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'submissionErrors',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'SubmissionError',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'validationErrors',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'ValidationError',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'TextBox',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'htmlText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'textRotation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'borderObject',
            type: {
              kind: 'OBJECT',
              name: 'BorderObject',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Tickbox',
        fields: [
          {
            name: 'codeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'hidden',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'routing',
            type: {
              kind: 'OBJECT',
              name: 'Routing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'subQuestionIndex',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'TickboxGroup',
        fields: [
          {
            name: 'alternateBackStyle',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'equalRowSpacing',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'equalColumnSpacing',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cosmeticItems',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CosmeticItem',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'responsePositioning',
            type: {
              kind: 'OBJECT',
              name: 'ResponsePositioning',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'isMatrix',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'layer',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'questionText',
            type: {
              kind: 'OBJECT',
              name: 'CosmeticItem',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'responses',
            type: {
              kind: 'OBJECT',
              name: 'Responses',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'subQuestionFields',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'SubQuestionField',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'tickboxes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'Tickbox',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'tickboxResponses',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'TickboxResponse',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'CaptureObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'TickboxResponse',
        fields: [
          {
            name: 'box',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Tickbox',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'label',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CosmeticItem',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'ordinal',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UrlLink',
        fields: [
          {
            name: 'dimensions',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Dimensions',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'fieldId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'guidId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'htmlText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'location',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Location',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'navigationType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'pageNavigationType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'pageNumber',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'questionCaption',
            type: {
              kind: 'OBJECT',
              name: 'QuestionCaption',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'text',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'uri',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'opensInNewTab',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'foreColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'backColor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'ObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'DesignObjectBase',
          },
          {
            kind: 'INTERFACE',
            name: 'Colours',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'ValidationError',
        fields: [
          {
            name: 'fieldId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'message',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'WebGroup',
        fields: [
          {
            name: 'authorisedProjects',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'canDownloadSubmittedDataAsCsv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'code',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'CsvDownloadPermissions',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'WebTheme',
        fields: [
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'data',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'WebUser',
        fields: [
          {
            name: 'authorisedProjects',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'canDownloadSubmittedDataAsCsv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'email',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fullName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'groups',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'WebGroup',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'mobileNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'username',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'CsvDownloadPermissions',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'WebUserProperties',
        fields: [
          {
            name: 'isAccountDisabled',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'isPasswordChangeRequired',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'SCALAR',
        name: 'Any',
      },
    ],
    directives: [],
  },
} as unknown as IntrospectionQuery;
